module.exports = __webpack_public_path__ + "img/contribute.721346c8.jpg";